/** Non-reactive registry so GlobalSync session trimming can keep Grid tiles warm. */
let activeGridSessionIDs = new Set<string>()

export function setActiveGridSessionIDs(ids: Iterable<string>) {
  activeGridSessionIDs = new Set(ids)
}

export function getActiveGridSessionIDs() {
  return activeGridSessionIDs
}

export function clearActiveGridSessionIDs() {
  activeGridSessionIDs = new Set()
}
